import { getDiscountTotalWithoutShippingCoupon } from '@cart-services/core/cartService'
import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { useFpCampaignCartService } from '@cart-services/hooks/useFpCampaignCartService'
import { Divider } from '@pets-ui/Divider/Divider'
import { FooterStack } from '@pets-ui/FooterStack/FooterStack'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'
import { FooterCheckout } from '../FooterCheckout/FooterCheckout'
import { FooterCoupon } from '../FooterCoupon/FooterCoupon'

export const CartFooter = () => {
  const { currency, campaignCode, campaignId, projectCode, countryCode } = useContextCampaignCart()
  const { isCartEmpty } = useFpCampaignCartService(campaignId)
  const { destructuredData: campaignCouponCalculateResult } = useFpCampaignCartCalculate(campaignId, campaignCode)
  const discountTotalWithoutShippingCoupon = getDiscountTotalWithoutShippingCoupon(campaignCouponCalculateResult?.discount_items || [])

  return (
    <FooterStack>
      <FooterCoupon
        projectCode={projectCode}
        campaignId={campaignId}
        countryCode={countryCode}
        campaignCode={campaignCode}
        currency={currency}
      />
      <Divider />
      <FooterCheckout
        currency={currency}
        elevation={0}
        amount={campaignCouponCalculateResult?.total}
        isCartEmpty={isCartEmpty}
        discountTotalWithoutShippingCoupon={discountTotalWithoutShippingCoupon}
      />
    </FooterStack>
  )
}
